
import { message } from "antd";
import {
  EnvironmentOutlined,
  IdcardOutlined,
  ProfileOutlined,
} from "@ant-design/icons";
import AgentMapWithPopup from "./AgentMapWithPopup";
import moment from "moment";
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { fetchAllocationDetails, getFieldAgentLocation } from "../../../assets/api/allocation";
import AgentDetailsTable from "../AgentDetailsTable/AgentDetailsTable";
import PanelCard from "../../../Pages/DashboardPage/components/PanelCard";
import "./AgentDetailsComp.scss";
import toast from "react-hot-toast";

const EMPTY = "—";

const initialsOf = (name) =>
  String(name || "")
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((word) => word[0])
    .join("")
    .toUpperCase();

const AgentDetailsComp = () => {
  const { state } = useLocation();
  const { token } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);
  const [cases, setCases] = useState([]);
  const [mapData, setMapData] = useState({
    loading: false,
    data: {}
  });

  useEffect(() => {
    const getAllocationDetails = async () => {
      if (!state?.id) {
        return;
      }
      setLoading(true)

      try {
        const res = await fetchAllocationDetails(state?.user_id, token);

        if (res?.status === 200) {

          setLoading(false)
          setCases(res?.data?.data || []);

        }
      } catch (error) {
        message.error(error?.message || "Failed to fetch agent details")

        setLoading(false)

      }
    };



    getAllocationDetails();
    getFAdetails();
  }, [state, token]);

  const getFAdetails = async () => {
    try {
      const res = await getFieldAgentLocation(token, state?.id);
      setMapData((prev) => ({
        ...prev,
        loading: true
      }))
      console.log(res, 'response');
      if (res?.status === 200) {
        setMapData((prev) => ({
          ...prev,
          data: res?.data?.data || {},
          loading: false
        }))
      } else {
        toast.error("Failed to fetch agent location");
        setMapData((prev) => ({
          ...prev,
          data: {},
          loading: false
        }))
      }
    } catch (error) {
      // Optionally handle error
    }
  }

  const details = useMemo(() => {
    /* Was moment(state?.date?._of_joinings) - there is no `date` object on
       the record and the key is misspelled, so this resolved to
       moment(undefined), i.e. now, and every agent appeared to have joined
       today. Read the field directly and only show a real date. */
    const joined = state?.date_of_joining
      ? moment(state.date_of_joining)
      : null;

    return [
      { label: "Mobile", value: state?.mobile_no, mono: true },
      { label: "Email ID", value: state?.email },
      {
        label: "Date of joining",
        value: joined?.isValid() ? joined.format("DD MMM YYYY") : null,
      },
      { label: "DRA Reg. No.", value: state?.dra_reg_no, mono: true },
      { label: "Total distance travelled", value: state?.Distance, mono: true },
      { label: "Total time taken", value: state?.Time, mono: true },
      { label: "Address", value: state?.address, wide: true },
    ];
  }, [state]);

  return (
    <div className="agent-details-main">
      <PanelCard
        title="Agent Details"
        icon={<IdcardOutlined />}
        accent="brand"
        className="agentIdentityCard"
      >
        <div className="agentIdentity">
          <div className="agentIdentity__who">
            <span className="agentIdentity__avatar" aria-hidden="true">
              {initialsOf(state?.name) || "NA"}
            </span>
            <div className="agentIdentity__text">
              <h3>{state?.name || EMPTY}</h3>
              <p>{state?.email || state?.mobile_no || EMPTY}</p>
            </div>
          </div>
          {state?.role && <span className="agentIdentity__role">{state.role}</span>}
        </div>

        <div className="agentDetailGrid">
          {details.map(({ label, value, mono, wide }) => (
            <div
              className={`agentDetailItem${wide ? " is-wide" : ""}`}
              key={label}
            >
              <span className="agentDetailItem__label">{label}</span>
              <span
                className={`agentDetailItem__value${mono ? " is-mono" : ""}${
                  value ? "" : " is-empty"
                }`}
              >
                {value || EMPTY}
              </span>
            </div>
          ))}
        </div>
      </PanelCard>

      <PanelCard
        title="Location Tracking"
        icon={<EnvironmentOutlined />}
        accent="brand"
        className="agentMapCard"
      >
        <AgentMapWithPopup data={mapData} showTimeline={true} />
      </PanelCard>

      <PanelCard
        title="Cases Assigned"
        icon={<ProfileOutlined />}
        accent="brand"
        className="agentCasesCard"
      >
        <AgentDetailsTable data={cases} loading={loading} />
      </PanelCard>
    </div>
  );
};

export default AgentDetailsComp;
